// import { useHistory } from 'react-router'

export const handleNavBack = () => {
  window.history.back()
  //   const history = useHistory()

  // history.goBack()
}
